module.exports = __webpack_public_path__ + "img/1003_sp.e49beab2.gif";